import { useScreenSize } from '@/hooks';

interface WarningIconProps {
    color?: string;
    width?: number;
    height?: number;
    className?: string;
    svgProps?: React.SVGProps<SVGSVGElement>;
}

const WarningIcon = ({ color = 'currentColor', width = 26, height = 26, className, svgProps }: WarningIconProps) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 26 26"
            fill="none"
            className={className}
            {...svgProps}
        >
            <path
                d="M9.61719 2.72559C11.4722 0.870595 14.48 0.870597 16.335 2.72559L23.2285 9.61816C25.0833 11.4731 25.0833 14.481 23.2285 16.3359L16.335 23.2295C14.48 25.0842 11.4721 25.0843 9.61719 23.2295L2.72461 16.3359C0.869618 14.4809 0.86962 11.4732 2.72461 9.61816L9.61719 2.72559Z"
                stroke={color}
                strokeWidth="2.5"
            />
            <rect x="12.2715" y="7.54102" width="2.01018" height="7.23667" rx="1.00509" fill={color} />
            <rect x="12.2715" y="16.8613" width="2.01018" height="2.01018" rx="1.00509" fill={color} />
        </svg>
    );
};

export default WarningIcon;
